import React from "react";
import { Link } from "react-router-dom";
import { styles } from "./style";
// import s from "./findhotspot.module.css";
import globalContext from "../../context/globalContext";
import { Card, TextField, Button } from "@material-ui/core";
import { withStyles, withTheme } from "@material-ui/core";
import s from "./style.module.css";
import label from "../../framework/whiteLabel";
// import { isNumeric } from "validator";
import { withRouter } from "react-router";
import { isAndroid } from "react-device-detect";
import cache, { cacheItems } from "../../framework/cache";

class FindHotspot extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {
      zip: cache.getItem(cacheItems.PREVIOUS_ZIP_CODE) ?? "",
      error: false,
      errorText: "",
      isFirstTap: true
    };
  }

  handleChange(ev) {
    if (this.state.zip.length < 6) {
      this.setState({ zip: ev.target.value.substring(0, 5) });
    }
  }

  render() {
    const { classes, theme } = this.props;
    let { zip, error, errorText, isFirstTap } = this.state;

    // console.log("zip", previousZip);

    return (
      <div className={s.container}>
        <Card className={classes.card}>
          <header style={{ padding: "2rem" }} className={classes.header}>
            Let's find you groceries
          </header>
          <div className={s.topImageContainer}>
            <img src={label.logoUrl} width={100} alt={""} />
          </div>
          <div className={s.zipContainer}>
            <TextField
              // className={classes.inputField}
              name="zip"
              type={"tel"}
              placeholder={"zip code"}
              label={"zip code"}
              onClick={
                isFirstTap
                  ? () => this.setState({ zip: "", isFirstTap: false })
                  : null
              }
              onChange={this.handleChange.bind(this)}
              value={zip}
              error={error ? errorText : ""}
              margin="normal"
              onBlur={() =>
                window.scrollTo({
                  top: 0,
                  behavior: "smooth"
                })
              }
            />
          </div>

          <Button
            className={classes.button}
            disabled={error || zip.length !== 5}
            onClick={async () => {
              document.activeElement.blur();
              // this.context.global.findHotSpot(this.state.zip);

              cache.setItem(cacheItems.PREVIOUS_ZIP_CODE, zip);
              setTimeout(
                () =>
                  this.props.history.push(`/find-hot-spot/${this.state.zip}`),
                500
              );
            }}
          >
            Search
          </Button>
          {/* <Button
            className={classes.button}
            variant="outlined"
            style={{ textTransform: "none" }}
            onClick={() => this.props.history.push(`/orders`)}
          >
            My Orders
          </Button> */}

          {/* <div
            style={{
              textAlign: "center",
              fontSize: "small",
              textDecoration: "underline",
              color: "#222",
              margin: "2rem 0px"
            }}
          >
            <a
              onClick={() => {
                this.props.history.push("/give");
              }}
            >
              Give the Gift of Groceries
            </a>
          </div> */}
          <div
            style={{
              textAlign: "center",
              fontSize: "small",
              textDecoration: "underline",
              color: "#222",
              margin: "1rem 0px"
            }}
            onClick={() => {
              this.context.global.logout();
            }}
          >
              Logout
          </div>
          <footer className={s.find_hot_spot_footer}>
            <div
              style={{
                display: "flex",
                alignItems: "baseline"
              }}
            >
              <p
                style={{
                  fontFamily: "Montserrat",
                  fontSize: 12
                }}
              >
                Looking for a
              </p>
              <Link
                to="/orders"
                style={{
                  marginLeft: 5,
                  textDecoration: "underline",
                  fontFamily: "Montserrat",
                  color: theme.palette.primary.main,
                  fontSize: 12
                }}
              >
                Previous Order?
              </Link>
            </div>
          </footer>
        </Card>
        {isAndroid && window.innerHeight < 650 ? (
          <div style={{ height: "300px", width: "100vw" }} />
        ) : null}
      </div>
    );
  }
}

export default withTheme()(withStyles(styles)(withRouter(FindHotspot)));
